import React from 'react';
import ScrollReveal from '../../components/ScrollReveal';
import { useLanguage } from '../../contexts/LanguageContext';

const History: React.FC = () => {
  const { tString } = useLanguage();
  return (
    <section id="nosotros" className="w-screen px-16 py-32 relative overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="w-full h-full bg-cover bg-center md:bg-fixed"
          style={{ backgroundImage: "url('/images/history_truck2.png')" }}
        >
          <div className="w-full h-full bg-[#282A2A]/80" />
        </div>
      </div>

      {/* Foreground content */}
      <div className="relative z-10 scroll-mt-40 flex flex-col-reverse md:flex-row items-center justify-center gap-14 max-w-5xl mx-auto">

        {/* DATA */}
        <div className="w-full md:w-2/3 text-center sm:text-left">
          <ScrollReveal direction="left" delay={0.2}>
            <h1 className="text-3xl font-encode font-bold text-[#ffffff] mb-4">
              {tString('history.title')}
            </h1>
          </ScrollReveal>
          <ScrollReveal direction="left" delay={0.4}>
            <p className="text-[#ffffff]/80 text-lg text-light mb-8">
              {tString('history.description')}
            </p>
          </ScrollReveal>
        </div>

        {/* IMAGE */}
        <div className="w-full md:w-1/3 flex justify-center">
          <ScrollReveal direction="right" delay={0.6}>
            <img
              src="/images/logo_gcl.png"
              alt={tString('history.imageAlt')}
              className="w-[300px] h-[180px] md:h-[250px] object-contain rounded-xl"
            />
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default History;
